import React from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useSaves } from "@/contexts/SavesContext";
import { toast } from "sonner";

export default function SaveHeart({ venueId, size = "md" }) {
  const { user } = useAuth();
  const { isSaved, toggle } = useSaves();
  const navigate = useNavigate();
  const saved = isSaved(venueId);
  const dims = size === "lg" ? "w-11 h-11" : "w-9 h-9";
  const iconDims = size === "lg" ? "w-5 h-5" : "w-4 h-4";

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast("Sign in to save places");
      navigate("/login");
      return;
    }
    const res = await toggle(venueId);
    if (res?.saved) toast.success("Saved to your places");
    else if (res?.saved === false) toast("Removed from saved");
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={saved ? "Remove from saved places" : "Save this place"}
      aria-pressed={saved}
      data-testid={`save-heart-${venueId}`}
      className={`${dims} inline-flex items-center justify-center rounded-full border-2 transition-colors duration-200 ${
        saved
          ? "bg-red-50 border-red-500 text-red-600"
          : "bg-white/95 border-gray-300 text-gray-500 hover:border-gray-900 hover:text-gray-900"
      }`}
    >
      <Heart className={`${iconDims} ${saved ? "fill-red-500 text-red-500" : ""}`} aria-hidden="true" />
    </button>
  );
}
